"use client";

import React, { useState } from "react";
import { Calculator, ArrowRight, HardHat } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
const wp_term_query_params = {
  taxonomy: "product_cat",
  per_page: 3,
  orderby: "count",
  order: "desc"
};
const wp_term_query = new WP_Term_Query(wp_term_query_params);
function YardageCalculator() {
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [depth, setDepth] = useState("");
  const l = parseFloat(length) || 0;
  const w = parseFloat(width) || 0;
  const d = parseFloat(depth) || 0;
  const yards = l * w * (d / 12) / 27;
  return;
}
function CategoryShowcase() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-[500px] bg-secondary/30 animate-pulse rounded-none border border-border" />)}
      </div>;
  }
  if (error || terms.length === 0) {
    return <div className="text-center py-24 border-2 border-dashed border-border bg-secondary/10">
        <HardHat className="mx-auto size-12 text-muted-foreground mb-4 opacity-50" />
        <p className="text-muted-foreground uppercase font-bold tracking-widest">
          Material catalog is currently being updated.
        </p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
      {terms.map((term, i) => <div key={term.id} data-index={i} className={`group relative h-[450px] md:h-[600px] overflow-hidden border border-border bg-secondary flex flex-col justify-end transition-transform duration-500 ${i === 1 ? "md:-translate-y-12" : ""}`}>
          {}
          {term.image_url ? <img src={term.image_url} alt={term.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110 opacity-50 group-hover:opacity-70 grayscale group-hover:grayscale-0" /> : <div className="absolute inset-0 bg-secondary" />}

          {}
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent opacity-95" />

          {}
          <div className="relative z-10 p-8 md:p-10 flex flex-col h-full justify-end">
            <div className="mb-auto flex justify-between items-start">
              <span className="inline-flex items-center justify-center w-12 h-12 bg-primary text-primary-foreground font-black text-xl rounded-none shadow-lg">
                0{i + 1}
              </span>
            </div>
            
            <h3 className="text-4xl md:text-5xl font-black uppercase tracking-tighter text-foreground mb-4 leading-none">
              {term.name}
            </h3>
            
            <p className="text-muted-foreground font-medium mb-8 line-clamp-3 text-sm md:text-base">
              {term.description || `Premium grade ${term.name.toLowerCase()} engineered for professional site preparation, foundations, and shoreline restoration projects.`}
            </p>
            
            <Button asChild size="lg" className="w-full sm:w-auto rounded-none bg-primary hover:bg-primary/90 text-primary-foreground font-black uppercase tracking-widest text-sm h-14 shadow-lg transition-all group-hover:translate-x-2">
              <Link to={term.link || "#"}>
                Shop {term.name} <ArrowRight className="ml-3 size-5" />
              </Link>
            </Button>
          </div>
        </div>)}
    </div>;
}
export default function BulkMaterialsDirect() {
  return <section id="bulk-materials-direct" className="dark bg-background text-foreground py-24 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: "linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)",
      backgroundSize: "4rem 4rem"
    }} />

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div className="text-center max-w-4xl mx-auto mb-16 md:mb-24">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-secondary border border-border rounded-none mb-6">
            <span className="w-2 h-2 bg-primary rounded-full animate-pulse" />
            <span className="text-xs font-bold uppercase tracking-widest text-muted-foreground">
              Direct-to-Site Delivery
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl font-black uppercase tracking-tighter mb-6 leading-[0.9]">
            The <span className="text-primary">Material</span> Shop
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground font-medium max-w-2xl mx-auto">Command your site with precision. Order bulk gravel, topsoil, stone and specialty aggregate directly to your property with our streamlined logistics engine.</p>
        </div>

        {}
        <div className="relative z-20 max-w-5xl mx-auto mb-12 md:-mb-16 px-4 md:px-0">
          <YardageCalculator />
        </div>

        {}
        <div className="pt-8 md:pt-32 pb-12">
          <EcommerceTermsProvider wp_term_query={wp_term_query}>
            <CategoryShowcase />
          </EcommerceTermsProvider>
        </div>
      </div>
    </section>;
}